/** @format */

import { Grid } from '@mui/material';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { Button } from 'src/components';
import Breadcrumb from 'src/components/Breadcrumb';
import { KnowledgeBaseItem } from 'src/components/knowledegeBase/item';
import { KnowledgeBaseSearch } from 'src/components/knowledegeBase/search';
import LoadingScreen from 'src/components/LoadingScreen';
import Page from 'src/components/Page';
import SelectComponent from 'src/components/select';
import useQuery from 'src/hooks/useQuery';
import { getKnowledgeBase, getKnowledgeBaseArticles } from 'src/slices/knowledgeBase';
import { useDispatch, useSelector } from 'src/store';

export default function KnowledgeBase() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { kb } = useParams();
  const query = useQuery().get('query');
  const { t } = useTranslation();
  const { knowledgeBase, knowledgeBaseLoading, knowledgeBaseArticles, knowledgeBaseArticlesLoading, error } =
    useSelector(state => state.knowledgeBase);
  const [category, setCategory] = useState(0);
  const [sort, setSort] = useState('cerated_desc');

  useEffect(() => {
    dispatch(getKnowledgeBase(kb));
  }, []);

  useEffect(() => {
    dispatch(
      getKnowledgeBaseArticles({
        kb: kb || 0,
        categories: category ? [category] : null,
        sort,
        query: query || ''
      })
    );
  }, [category, sort, query]);

  const pageTitle = knowledgeBase?.title || '';

  if (error || !kb) return <Navigate to="/404" replace />;
  if (knowledgeBaseLoading) return <LoadingScreen />;
  return (
    <Page className={`knowledge-base`} title={pageTitle}>
      <Breadcrumb data={[{ title: pageTitle }]} />
      <Grid className="knowledge-base-container">
        <Grid className="knowledge-base-title-box">
          <h1 className="knowledge-base-title">{pageTitle}</h1>
          <KnowledgeBaseSearch kb={kb} />
        </Grid>
        <Grid className="knowledge-base-text" dangerouslySetInnerHTML={{ __html: knowledgeBase?.body }} />
        <Grid className="knowledge-base-categories-sort">
          <h3>{t('common.categories')}</h3>
          <Grid className="knowledge-base-categories-sort-flex">
            <ul className="knowledge-base-categories">
              <li>
                <button className={category === 0 ? `active` : ''} onClick={() => setCategory(0)}>
                  {t('common.all')}
                </button>
              </li>
              {knowledgeBase?.categories?.map(cat => (
                <li key={cat.id}>
                  <button className={category === cat.id ? `active` : ''} onClick={() => setCategory(cat.id)}>
                    {cat.name}
                  </button>
                </li>
              ))}
            </ul>
            <Grid className="knowledge-base-sort">
              <SelectComponent
                label={t('common.sort.sortBy')}
                options={[
                  { value: 'cerated_desc', name: t('common.sort.newestDesc') },
                  { value: 'cerated_asc', name: t('common.sort.newestAsc') },
                  { value: 'title_asc', name: t('common.sort.alphabeticalAsc') },
                  { value: 'title_desc', name: t('common.sort.alphabeticalDesc') }
                ]}
                onChange={e => e.target.value && setSort(e.target.value)}
                value={sort}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid className="knowledge_base-widget--list knowledge-base-list">
          {knowledgeBaseArticlesLoading ? (
            <LoadingScreen />
          ) : knowledgeBaseArticles?.length > 0 ? (
            knowledgeBaseArticles.map(item => <KnowledgeBaseItem item={item} kb={kb} key={item.nid} />)
          ) : (
            <p className="knowledge_base-widget--list-empty">{t('common.noResults')}</p>
          )}
        </Grid>
        <Button onClick={() => navigate(`/dashboard`)} borderOnly back label={t('common.button.backToHome')} />
      </Grid>
    </Page>
  );
}
